import { PaymentApiClient } from '@fourthwall/services/dist/PaymentApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useIsPaymentMethodModalRequiredMutation = createMutationHook(
  PaymentApiClient.isPaymentMethodModalRequired,
  {
    mutationKey: ['isPaymentMethodModalRequired'],
  },
)
